<div class="compo-content-wrapper">
  <div class="compo-content">
    <div *ngIf="schemas.length || isLoading" class="h-100 d-flex flex-column">
      <div class="tdg-header-tabs" *ngIf="schemas.length">
        <div
          class="tdg-tab"
          [ngClass]="{
            active:
              tab.testCaseId === selectedSchema.testCaseId ||
              tab.db_name === selectedSchema.db_name,
          }"
          *ngFor="let tab of schemas"
          (click)="switchTab(tab)"
          (keydown.enter)="switchTab(tab)"
        >
          <span> {{ tab.testCaseId || tab.db_name }} </span>
        </div>
      </div>

      <div class="button-div">
        <div class="d-flex">
          <div class="table-summary" *ngIf="totalRecords > 0">
            <span>Showing rows </span> <strong>{{ startRow }}</strong>
            <span> to </span><strong>{{ endRow }}</strong> <span> of </span>
            <strong>{{ totalRecords }}</strong>
          </div>
        </div>

        <div class="d-flex">
          <button
            type="button"
            class="btn-accello-delete mx-2 visually-hidden-space"
            [disabled]="selectedRows.length === 0"
            (click)="onClickAction('delete')"
          >
            <img [src]="'images/virtusa-icons/delete-red.svg' | assetUrl" alt="Delete" />
            Delete Row(s)
          </button>

          <button
            type="button"
            class="btn-accello-secondary mx-2"
            (mousedown)="isNewRow = true"
            (mouseup)="isNewRow = false"
            (mouseleave)="isNewRow = false"
            (click)="onClickAction('insert-row')"
          >
            <img
              [src]="(isNewRow ? 'images/virtusa-icons/insert-row-white.svg' : 'images/virtusa-icons/insert-row.svg') | assetUrl"
              alt="Insert row"
            />
            Insert Row
          </button>

          <button
            type="button"
            class="btn-accello-secondary mx-2"
            (mousedown)="isRegen = true"
            (mouseup)="isRegen = false"
            (mouseleave)="isRegen = false"
            (click)="onClickAction('re-generate')"
          >
            <img
              [src]="(isRegen ? 'images/virtusa-icons/re-gen-white.svg' : 'images/virtusa-icons/re-gen.svg') | assetUrl"
              alt="Regenerate"
            />
            Regenerate
          </button>

          <button
            type="button"
            class="btn-accello-secondary mx-2"
            (mousedown)="isSave = true"
            (mouseup)="isSave = false"
            (mouseleave)="isSave = false"
            (click)="onClickAction('save')"
          >
            @if (isSaving) {
              <span
                class="spinner-border spinner-border-sm mx-2"
                aria-hidden="true"
              ></span>
            } @else {
              <img
                [src]="(isSave ? 'images/virtusa-icons/save-icon-white.svg' : 'images/virtusa-icons/save-icon.svg') | assetUrl" 
              alt='Save'
              />
            }
            Save
          </button>
        </div>
      </div>

      <div class="tdg-sub-tab-content d-flex flex-grow-1">
        <div class="py-2 flex-grow-1 d-flex flex-column overflow-hidden">
          <app-zorro-table
            [tableId]="'tdg_combined_table'"
            [enableHorizontalScroll]="true"
            *ngIf="!isLoading && schemas.length"
            tableId="tdg-dt-source"
            class="w-100"
            [columns]="selectedSchema.tables[0].columns"
            [data]="selectedSchema.tables[0].rawData"
            (onRowSelect)="onTableRowSelect($event)"
            (pageChange)="onPageChange($event)"
          >
          </app-zorro-table>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="errorData?.length > 0" class="error-div w-100">
    <img [src]="'images/virtusa-icons/warning.svg' | assetUrl" alt="tip" />
    <span>{{ errorText }}</span>
    <strong (click)="openValidationError()" (keydown.enter)="openValidationError()">View details</strong>
  </div>
</div>
